<div class="wc-profiles-toolbar">
  <div class="container-fluid">
    <form class="form-horizontal">
      <span class="input-group">
        <span class="input-group-btn">
          <button pButton type="button" class="btn btn-default" [disabled]="_searching.busy"
            [icon]="_searching.busy || _inlineSearching.busy ? null : 'pi pi-search'"
            (click)="handleSearchFormSubmit()">
            <wl-busy *ngIf="_searching.busy || _inlineSearching.busy" [show]="true"></wl-busy>
          </button>
        </span>
        <input type="text" class="form-control" name="profileToolbarSearchKeyword" [(ngModel)]="keyword"
          (ngModelChange)="handleModelChange()" autocomplete="off"
          placeholder="{{ 'shared.container.toolbars.module.profiles.search-profiles-placeholder' | translate | ucfirst }}" />
        <span class="input-group-btn">
          <button pButton type="button" class="btn btn-default" icon="pi pi-times-circle"
            [hidden]="(!keyword || (keyword && !keyword.length)) && !_isProfileSearchPage"
            [disabled]="_searching.busy || _inlineSearching.busy" (click)="handleResetClick()"></button>

          <button type="button" pButton class="btn btn-default hidden-xs new-profile-button"
            [label]="'shared.container.toolbars.module.profiles.new-profile-label' | translate | titlecase"
            (click)="handleNewProfileClick()" [icon]="'large-icon pi pi-plus'">
          </button>
        </span>
      </span>
      <div *ngIf="_resultsOpen && !_inlineSearching.busy" class="wc-profiles-toolbar-search-result-outer-container">
        <div class="wc-profiles-toolbar-search-result-container">
          <div class="wc-profiles-toolbar-search-result">
            <div class="text-danger" *ngIf="!_inlineSearching.busy && !_inlineSearching.success">
              {{ _inlineSearching.message }}
            </div>

            <div *ngIf="!_inlineSearchResults.length && !_inlineSearching.busy && _inlineSearching.success">
              {{ 'shared.container.toolbars.module.profiles.no-results' | translate | ucfirst }}
            </div>

            <ul class="list-unstyled"
              *ngIf="_inlineSearchResults.length && !_inlineSearching.busy && _inlineSearching.success">
              <li *ngFor="let profile of _inlineSearchResults; let i = index" class="wc-toolbar-profile-results-row"
                (click)="closeResults()">
                <!-- <a [routerLink]="['/profile/', profile.ProfileId]" (click)="closeResults()">{{ profile.ReportName }}</a> -->
                <div class="mct-basis-25" [routerLink]="['/profile/', profile.ProfileId]">
                  <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd"
                    [memberTypeIconColor]="profile.MemberTypeIconColor"
                    [styleOverrides]="{ 'max-height': '34px', 'max-width': '34px' }"></wl-profile-type-icon>
                  {{ profile.ReportName }}
                  <span class="profile-id">&nbsp;({{ profile.ProfileId }})</span>
                </div>
                <div class="mct-flex mct-col mct-justify-around mct-items-stretch mct-basis-55"
                  [routerLink]="['/profile/', profile.ProfileId]">
                  <div [hidden]="!profile.MainRelatedProfileName">
                    <strong>{{ profile.MainRelatedProfileName }}</strong>
                  </div>
                  <div [hidden]="!profile.Address1">{{ profile.Address1 }}</div>
                  <div [hidden]="!profile.Address2">{{ profile.Address2 }}</div>
                  <div [hidden]="!profile.City && !profile.State && !profile.Zip">
                    {{ profile.City ? profile.City + ', ' : '' }}
                    {{ profile.State }}
                    {{ profile.Zip }}
                  </div>
                </div>
                <div class="mct-flex mct-row mct-justify-around mct-items-stretch mct-basis-20">
                  <div style="height: 32px">
                    <button pButton type="button" id="“profile-quicksearch-edit-profile”" type="button"
                      class="btn btn-default" (click)="navigateToProfileEdit(profile.ProfileId)">
                      {{ 'shared.container.toolbars.module.profiles.edit-profile' | translate | titlecase }}
                    </button>
                    <button pButton type="button" id="“profile-quicksearch-view-transactions”" type="button"
                      class="btn btn-default ml-20" (click)="navigateToViewTransactions(profile.ProfileId)">
                      {{ 'shared.container.toolbars.module.profiles.view-transactions' | translate | titlecase }}
                    </button>
                  </div>
                </div>
              </li>
              <li class="wl-toolbar-click-for-more">
                {{ 'shared.container.toolbars.module.profiles.for-more-results' | translate | ucfirst }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="visible-xs-block">
        <button app-add-button
          [label]="'shared.container.toolbars.module.profiles.new-profile-label' | translate | titlecase"
          (onClick)="handleNewProfileClick()"></button>
      </div>
    </form>
  </div>
</div>
